import { render, staticRenderFns } from "./FooterRow.vue?vue&type=template&id=037bcc6e&scoped=true&"
import script from "./FooterRow.vue?vue&type=script&lang=js&"
export * from "./FooterRow.vue?vue&type=script&lang=js&"
import style0 from "./FooterRow.vue?vue&type=style&index=0&id=037bcc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037bcc6e",
  null
  
)

export default component.exports